import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionState } from '../../common/enums/selection-state.enum';
import { TableSelectionInfoBase } from '../../common/interfaces/table-selection-info-base';
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
    selector: 'lib-table-selection-banner',
    standalone: true,
    imports: [
        CommonModule,
        TooltipComponent
    ],
    templateUrl: './table-selection-banner.component.html',
    styleUrl: './table-selection-banner.component.scss'
})
export class TableSelectionBannerComponent {
    @Input() selectionInfo!: TableSelectionInfoBase;
    @Input() showDownloadCsv = false;
    @Input() showSendVerificationEmail = false;
    @Input() showManualSelection = false;
    @Input() showPreconfigure = false;
    @Input() disableDownloadCsv = false;
    @Input() downloadCsvTooltip: string | undefined = undefined;
    @Input() entityName = 'Accounts';

    @Output() selectAll = new EventEmitter<void>();
    @Output() clearSelection = new EventEmitter<void>();
    @Output() downloadCsv = new EventEmitter<void>();
    @Output() sendVerificationEmail = new EventEmitter<void>();
    @Output() preconfigure = new EventEmitter<void>();

    get isPageSelection(): boolean {
        return this.selectionInfo?.state === SelectionState.PAGE;
    }

    get isAllSelection(): boolean {
        return this.selectionInfo?.state === SelectionState.ALL;
    }

    get isManualSelection(): boolean {
        return this.selectionInfo?.state === SelectionState.MANUAL;
    }
}
